import { configureStore } from "@reduxjs/toolkit";
// Or from '@reduxjs/toolkit/query/react';
// import { setupListeners } from '@reduxjs/toolkit/query';

import userReducer from "./Data/features/userSlice";
import sessionMiddleware from "./Data/middleware/sessionMiddleware";

import { packingItemsApi } from "./Data/services/PackingItems";
import { baseApi } from "./Data/services/baseApi";
import { changePasApi } from "./Data/services/changePassApi";
import { dashboardApi } from "./Data/services/dashboardApi";
import { packingApi } from "./Data/services/packingApi";
import { questionsApi } from "./Data/services/questionsApi";
import { travelInsightApi } from "./Data/services/travelInsightApi";
import { tripCreatorApi } from "./Data/services/tripCreatorApi";
import { userApi } from "./Data/services/userApi";
import { userAuthApi } from "./Data/services/userAuthApi";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    // RTK Query API
    [userAuthApi.reducerPath]: userAuthApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [changePasApi.reducerPath]: changePasApi.reducer,
    [questionsApi.reducerPath]: questionsApi.reducer,
    [travelInsightApi.reducerPath]: travelInsightApi.reducer,
    [tripCreatorApi.reducerPath]: tripCreatorApi.reducer,
    [packingApi.reducerPath]: packingApi.reducer,
    [packingItemsApi.reducerPath]: packingItemsApi.reducer,
    // Local storage Redux
    user: userReducer,
  },
  // load from local storage
  // preloadedState: loadFromLocalStorage(), //todo:

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  //todo:
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      // userAuthApi.middleware,
      baseApi.middleware,
      userApi.middleware,
      changePasApi.middleware,
      sessionMiddleware, // for session check each api response
    ]),
});

//todo:
// function saveToLocalStorage(state) {
//     try {
//         const serialState = JSON.stringify(state)
//         localStorage.setItem("reduxStore", serialState)
//     } catch (e) {
//         console.warn(e);
//     }
// }

//todo:
// function loadFromLocalStorage() {
//     try {
//         const serialisedState = localStorage.getItem("reduxStore");
//         if (serialisedState === null) return undefined;
//         return JSON.parse(serialisedState);
//     } catch (e) {
//         console.warn(e);
//         return undefined;
//     }
// }

//todo:
// store.subscribe(() => saveToLocalStorage(store.getState()));

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
// setupListeners(store.dispatch) //todo:
